module.exports = __webpack_public_path__ + "static/media/story_6.d1888054.png";